const validateExtensions = (file, extensions) => {
    const { name } = file;
    let valid = false;
    for (let j = 0; j < extensions.length; j += 1) {
        const extension = extensions[j]
        if (name.substr(name.length - extension.length, extension.length).toLowerCase() === extension.toLowerCase()) {
            valid = true;
            break;
        }
    }
    return valid;
}

 
const validateFileSize = (file, maxSize) => file.size <= maxSize;

const errorText = {
    maxsize: 'Превышен лимит размера файла 5 МБ',
    type: 'Ошибка. Неверный формат файла.',
}
 
const extensions = ['.doc', '.docx', '.pdf', '.jpg', '.jpeg', '.png'];
const maxFileSize = 5000000;
const uploadFileInput = $('.js-uploadFileInput');
const filesDrop = $('.js-filesDrop');
const uploadFileList = $('.js-uploadFileList');

// Проверка поддержки браузером
if(typeof(window.FileReader) == 'undefined') {
    console.log('Не поддерживается браузером!');
    filesDrop.addClass('is_error_filereader');
}
 
// Добавляем класс hover при наведении
filesDrop.on('dragover', function(event){
    event.preventDefault();
    event.stopPropagation();
    filesDrop.addClass('is_hover');
});
 
// Убираем класс hover
filesDrop.on('dragleave', function(event){
    event.preventDefault();
    event.stopPropagation();
    filesDrop.removeClass('is_hover');
});
 
// Обрабатываем событие Drop
filesDrop.on('drop', function(event){
    const file = event.originalEvent.dataTransfer.files;
 
    event.preventDefault();
    event.stopPropagation();
 
    filesDrop.removeClass('is_hover');
    filesDrop.addClass('is_drop');
    uploadFileInput.prop('files', file).trigger('change');
 
    return false;
});
 
uploadFileInput.on('change', (event) => {
    const _this = $(event.currentTarget);
    const file = event.target.files[0];
    const uploadErrorText = filesDrop.find('.js-uploadErrorText');
 
    if(validateExtensions(file, extensions) && validateFileSize(file, maxFileSize)){
        appendFileTemplate({ file });
 
        filesDrop.removeClass('is_error');
    } else {
        if(!validateFileSize(file, maxFileSize)){
            uploadErrorText.text(errorText.maxsize);
        } else {
            uploadErrorText.text(errorText.type);
        }
        filesDrop.addClass('is_error');
    }
});

$(document).on('click', '.js-uploadErrorClose', (event) => {
    $('.js-filesDrop').removeClass('is_error');
});
 
$(document).on('click', '.js-fileDelete', (event) => {
    const _this = $(event.currentTarget);
    const element = _this.parents('.fieldset-file__active-load');
 
    element.remove();

    $('.js-filesDrop').removeClass('is-success');
});
 
function appendFileTemplate({ file }){
    $('.js-filesDrop').addClass('is-success');

    const tpl = `
        <div class="fieldset-file__active-load">
            <div class="fieldset-file__active-icon">
                <svg class="icon-file-success" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                  <g transform="translate(-272 -12)">
                    <g transform="translate(-159 -3255)">
                      <g transform="translate(431 3267)" fill="none" stroke="#17aa54" stroke-width="1">
                        <circle cx="8" cy="8" r="8" stroke="none"/>
                        <circle cx="8" cy="8" r="7.5" fill="none"/>
                      </g>
                    </g>
                    <path d="M277.4,20.3l2.5,2.5,4.5-4.5" transform="translate(-0.599 -0.505)" fill="none" stroke="#0dab54" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  </g>
                </svg>
            </div>
            <div class="fieldset-file__active-name">${file.name}</div>
            <div class="fieldset-file__active-reset js-fileDelete">
                <svg class="icon-file-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                  <g transform="translate(-431 -3267)">
                    <g transform="translate(431 3267)" fill="none" stroke="currentColor" stroke-width="1">
                      <circle cx="8" cy="8" r="8" stroke="none"/>
                      <circle cx="8" cy="8" r="7.5" fill="none"/>
                    </g>
                    <rect width="1" height="8" rx="0.5" transform="translate(441.475 3271.818) rotate(45)" stroke="currentColor"/>
                    <rect width="0.999" height="8" rx="0.5" transform="translate(442.182 3277.475) rotate(135)" stroke="currentColor"/>
                  </g>
                </svg>
            </div>
            <div class="fieldset-file__error"></div>
        </div>
    `
 
    uploadFileList.append(tpl);
}
 